import { relatorio_de_situacao_final_dos_alunos } from "./relatorio-de-situacao-final-dos-alunos";
import { consultar_resumo_de_resultado_finais } from "./consultar-resumo-de-resultado-finais";
const acompanhamento_de_resultados_finais = [
  ...relatorio_de_situacao_final_dos_alunos,
  ...consultar_resumo_de_resultado_finais,
];

export { acompanhamento_de_resultados_finais };
